import React  from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
// import Cookies from "js-cookie"{ useEffect, useState };
//import PopupPage from "../PopupPage";

function Home() {
  // const [hasVisited, setHasVisited] = useState(false);

  // useEffect(() => {
  //   const visited = Cookies.get("visited");
  //   if (visited === "true") {
  //     setHasVisited(true);
  //   } else {
  //     Cookies.set("visited", "true");
  //   }
  // }, []);

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> SOHEEL GADAD</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>

      <Home2 />

     {/* <PopupPage />
      {hasVisited ? <div>Welcome back!</div> : <PopupPage />}*/}
    </section>
  );
}

export default Home;
